<template>
	<div class="table-responsive">
         <table class="table table-border">
			<thead >
				<tr>
					<th scope="col" style="width:10%">Total Income</th>
                    <th scope="col" style="width:12%"> B/L {{year-1}} </th>
					<th v-bind:class="{'active-month': currentMonth == 1}"  style="width:6%;text-align:center" scope="col">Jan</th>
					<th v-bind:class="{'active-month': currentMonth == 2}"  style="width:6%;text-align:center" scope="col">Feb</th>
					<th v-bind:class="{'active-month': currentMonth == 3}"  style="width:6%;text-align:center" scope="col">Mar</th>
					<th v-bind:class="{'active-month': currentMonth == 4}"  style="width:6%;text-align:center" scope="col">Apr</th>
					<th v-bind:class="{'active-month': currentMonth == 5}"  style="width:6%;text-align:center" scope="col">May</th>
					<th v-bind:class="{'active-month': currentMonth == 6}"  style="width:6%;text-align:center" scope="col">Jun</th>
					<th v-bind:class="{'active-month': currentMonth == 7}"  style="width:6%;text-align:center" scope="col">Jul</th>
					<th v-bind:class="{'active-month': currentMonth == 8}"  style="width:6%;text-align:center" scope="col">Aug</th>
					<th v-bind:class="{'active-month': currentMonth == 9}"  style="width:6%;text-align:center" scope="col">Sep</th>
					<th v-bind:class="{'active-month': currentMonth == 10}" style="width:6%;text-align:center" scope="col">Oct</th>
					<th v-bind:class="{'active-month': currentMonth == 11}" style="width:6%;text-align:center" scope="col">Nov</th>
					<th v-bind:class="{'active-month': currentMonth == 12}" style="width:6%;text-align:center" scope="col">Dec</th>
					<th scope="col" style="width:6%;text-align:center">Total</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="propertyFee, key, index in propertyFees">
					<td scope="row">  {{ propertyFee.propertyName }}</td>
                    <td v-bind:class="{'active-month-column': currentMonth == (key2)}" style="text-align:center"  v-for="fee, key2 in propertyFee.fees">
                        <div v-if="key2 < 13">
                            <div v-if="key2  > currentMonth">
                                -
                            </div>
                            <div v-else>
                                <div v-if="key2 + 1 < currentMonth && key2 + 1 > 0">
                                    <div v-if="fee == 0">
                                        -
                                    </div>
                                    <div v-else>
                                        {{ $filters.toCurrency(fee) }}
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-if="fee == 0">
                                        -
                                    </div>
                                    <div v-else>
                                        {{ $filters.toCurrency(fee) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <strong>
                                <div v-if="fee == 0">
                                    -
                                </div>
                                <div v-else>
                                    {{ $filters.toCurrency(fee) }}
                                </div>
                            </strong>
                        </div>
                    </td>
                </tr>
                <tr>
					<td scope="row">
						<strong>
							Total
						</strong>
					</td>
					<td v-bind:class="{'active-month-column': currentMonth == (key3)}" style="text-align:center" v-for="total,key3 in totalFees">
                        <div v-if="key3 == currentMonth || key3 == 0">
                            <strong>	
                                <div v-if="total == 0">
                                    -
                                </div>
                                <div v-else>
                                    {{ $filters.toCurrency(total) }}
                                </div>
                            </strong>
                        </div>
						<div v-else>
                            <div>
                                <strong> 
                                    <div v-if="total == 0">
                                        -
                                    </div>
                                    <div v-else>
                                        {{ $filters.toCurrency(total) }}
                                    </div>
                                </strong> 
                            </div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { authenticationService } from '@/_services';
    export default {
		props : ['buildingId', 'route','period','filter'],
        data: function () {
  return {
	propertyFees : [], 
	totalFees : [],
	index : 0,
	isModalVisible: true,
	propertyId: 0,
    monthParam: 0,
    currentUser:null,
      year: 0,
      currentMonth: 0
  }
},
 watch: {
    value(val) {
      this.$emit('update:buildingId', val);
    },
    buildingId(val) {
      this.value = val;
      this.fetchStatement();
    }
  },
  created(){
      authenticationService.currentUser.subscribe(x => this.currentUser = x);
  },
                                
                    mounted() {
                        if(this.buildingId)
                            this.fetchStatement();
                        //this.propertyHistory = JSON.parse(this.propertyAttribute)
                        
                        //console.log(this.propertyAttribute)
                        //this.propertyHistory = this.propertyAttribute

                        if (!this.$period.isCurrent(this.period)) {
                            this.currentMonth = 12;
                            this.year = new Date().getFullYear()-(Number(this.period) - 1);
                        } else{
                            this.year = new Date().getFullYear();
                            this.currentMonth = new Date().getMonth() + 1;
                        }
                    },

                    methods: {
                        beforeOpen (event) {
                            this.propertyId = event.params.creditortypeid;
                            this.monthParam = event.params.month + 1;
                    },
                                    showModal() {
                    this.isModalVisible = true;
                    alert(this.isModalVisible)
                    },
                    closeModal() {
                    this.isModalVisible = false;
                    },
					/*fetchStatement: function(){
							this.mute = true;
							var request = '/admin/statment/collected/get/';
							if(this.route =="home")
								request = '/home/statment/collected/get/';
							
							request = request+this.buildingId;
                            request = request + '/' + (this.period == null ? 1 : this.period);
                            window.axios.get(request).then(({data}) => {
                                    
                                this.mute = false;
                                this.propertyFees = JSON.parse(data.propertyFees);
                                this.totalFees = data.totalFees;
					});
					
                    },*/
                    
                    fetchStatement: function(){
							this.mute = true;
						var request = '/statement/totalIncome';
               // if(this.route=="home")
                 //   request = '/home/statment/get/';
                 if(this.currentUser.role === "Owner")
                    request = request+'/owner?id='+this.buildingId+'&userid='+ this.currentUser.id +'&period='+this.period;
                 else
                    request = request+'?id='+this.buildingId+'&period='+this.period;
              /*  if(this.period == 2)	
                    request = request +'/'+this.period;
                else
                    request = request +'?id='+this.buildingId;*/
                  
                    this.$http.get(request, {
                        id : this.buildingId
                    }).then(({data}) => {
                                this.mute = false;
                                //this.contacts = data.contacts;
                           this.mute = false;
                    // let myObjStr = JSON.stringify(data.expenseFees);
                    this.propertyFees = data.propertyFees;
                    this.totalFees = data.totalFees;

                });
							


					},
                    showModalTemp: function(propertyId, month){
                            //this.$modal.show('creditors-form', { 'creditortypeid': creditorId,  'month' : month});
                        //alert("Id " + expenseId + " month " + month);
                        //this.isModalVisible = true;
                        
                    },
                                        show () {
   // this.$modal.show('creditors-form');
  },
  hide () {
   // this.$modal.hide('creditors-form');
  },

            /**
             * Prepare the component.
             */
            
            },
			
			computed : {
				getProperties() {
      
                    var propertyFees = this.propertyFees.filter((propertyFee) => {
					
												if(this.filter)
													return propertyFee.propertyName.toLowerCase().includes(this.filter.toLowerCase());
												else
													return this.propertyFees;
                        });
                    
                    return propertyFees;
                    
                    },
			total: function(){
				return this.propertyFees[0].reduce(function(total, fees){

                return total + fees[0]; 
				},0);
        },
			}

	}                // Our Javascript logic
    
    
</script>
